import * as React from "react";
import { Icon } from "../Icon/icon";
import { setInnerHtml } from "../../utils/helpers";

interface IAttentionBoxProps {
  heading?: string;
  bodytext: string;
  cssClass?: string;
  icon?: string;
}

const AttentionBox: React.FunctionComponent<IAttentionBoxProps> = (props) => {
  const { heading, bodytext, cssClass, icon } = props;
  const noHeaderButIcon = !heading && icon;
  return (
    <div className={`attentionbox ${cssClass}`}>
      <div
        className={`attentionbox__body ${
          noHeaderButIcon ? "attentionbox__body--noheader" : ""
        }`}
      >
        {heading && (
          <div className="attentionbox__header">
            {icon && <Icon iconType={icon} />}
            {heading}
          </div>
        )}
        {noHeaderButIcon && <Icon iconType={icon} />}
        <div
          className={`attentionbox__content ${
            noHeaderButIcon ? "attentionbox__content--noheader" : ""
          }`}
          dangerouslySetInnerHTML={setInnerHtml(bodytext)}
        />
      </div>
    </div>
  );
};

export default AttentionBox;
